import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Auffangseite fuer unbekannte Adressen — insbesondere fuer alte
 * Angebotslinks (/angebot/:slug), die es nicht mehr gibt.
 */
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
    <div className="max-w-md text-center">
      <div className="w-14 h-14 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center mx-auto mb-5 text-2xl font-bold">
        ?
      </div>
      <h1 className="text-xl font-bold text-gray-900 mb-2">Diese Seite gibt es nicht mehr</h1>
      <p className="text-gray-600 text-sm leading-relaxed mb-6">
        Moeglicherweise nutzen Sie einen aelteren Angebotslink. Ihr aktuelles Angebot
        erhalten Sie von Ihrem Ansprechpartner bei AIQCON — melden Sie sich gerne kurz,
        dann senden wir es Ihnen erneut zu.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <a
          href="mailto:energie@aiqcon.com"
          className="px-4 py-2.5 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium"
        >
          energie@aiqcon.com
        </a>
        <Link
          to="/"
          className="px-4 py-2.5 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 text-sm font-medium"
        >
          Zur Startseite
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
